export enum OrderSortType {
  ALL = "ALL", // 전체
  INVOICE_STATUS = "INVOICE_STATUS", // 발주순
  PAYMENT_STATUS = "PAYMENT_STATUS", // 결제상태순
}

export const orderSortTypeDisplayNames = {
  [OrderSortType.ALL]: "전체",
  [OrderSortType.INVOICE_STATUS]: "발주순",
  [OrderSortType.PAYMENT_STATUS]: "결제상태순",
};
